import { isValidWindow, resolveDateWindow, type DateWindow } from "@nexus/contracts";
import { resolvePresetWindow } from "./explore-date-presets";

export type DashboardRequestWindowInput = {
  dateRange: string;
  startDate?: string;
  endDate?: string;
  activePresetId?: string;
};

/**
 * Window the Dashboard page puts on the wire. Store dates win when valid;
 * a catalog preset with empty dates resolves against today; anything else
 * falls back to the `dateRange` token.
 */
export function resolveDashboardRequestWindow(
  filters: DashboardRequestWindowInput,
  today: Date = new Date(),
): DateWindow {
  const startDate = filters.startDate ?? "";
  const endDate = filters.endDate ?? "";
  if (isValidWindow({ startDate, endDate })) {
    return { startDate, endDate };
  }

  if (filters.activePresetId) {
    const preset = resolvePresetWindow(filters.activePresetId, today);
    if (preset) return { startDate: preset.start, endDate: preset.end };
  }

  return resolveDateWindow(
    { dateRange: filters.dateRange, startDate: "", endDate: "" },
    today,
  );
}
